import { submitForm } from '../submitForm';

export function logoutOidcProvider(endSessionUrl: string, idToken: string, state?: string): void {
    const body = {
        id_token_hint: idToken,
    };

    if (state) {
        Object.assign(body, { state });
    }

    submitForm(endSessionUrl, {
        method: 'POST',
        body,
    });
}
